import { css } from '@emotion/core';
import styled from '@emotion/styled';

const wrapperStyles = ({
  theme: {
    work,
    grid: { breakpoint },
  },
}) => css`
  overflow: hidden;
  background: ${work.sesameQuaternary};
  padding: 0 15px;
  margin: 0 -15px;
  ${breakpoint.min730} {
    padding: 0 150px;
    display: grid;
    grid-template-columns: 500px 1fr;
    min-height: 100vh;
  }
`;

const sectionStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  padding: 70px 0 30px;
  ${breakpoint.min730} {
    width: 500px;
    margin-top: 150px;
    padding: 0;
  }
`;

const imageWrapperStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => `
  width: calc(100% + 2 * 15px);
  display: flex;
  margin-bottom: -25px;
  ${breakpoint.min730} {
    width: 100%;
    align-items: flex-end;
    grid-column-gap: 20px;
  }
`;

const imageItemWrapperStyles = ({
  theme: {
    grid: { breakpoint },
  },
  isMainImage,
}) =>
  isMainImage
    ? `
      width: 100%;
      ${breakpoint.min730} {
        width: 750px;
        margin-right: -120px;
        margin-left: 150px;
      }
    `
    : `
      display: none;
      ${breakpoint.min730} {
        width: 270px;
        display: block;
      }
    `;

/**
 * Component style declarations
 */
export const Wrapper = styled('div')(wrapperStyles);
export const Section = styled('div')(sectionStyles);
export const ImageWrapper = styled('div')(imageWrapperStyles);
export const ImageItemWrapper = styled('div')(imageItemWrapperStyles);
